namespace GeniuzPOS.Inventory {
    export interface IcStockAdjOutData extends Serenity.ListRequest {
        Header?: IcStockAdjustOutRow;
        Adjcode?: IcStkAdjCodeRow;
        Details?: IcStockAdjustOutDtRow[];
        SysDocNo?: string;
        Para?: Administration.CsParaRow;
        URLpic?: string;
        BizName?: string;
        BizAddressLine1?: string;
        BizAddressLine2?: string;
        BizAddressLine3?: string;
        TaxId?: string;
    }
}
